<template>
    <div>
        <div
            :data-active="active"
            @dragenter.prevent="setActive"
            @dragover.prevent="setActive"
            @dragleave.prevent="setInactive"
            @drop.prevent="onDrop"
        >
            <slot :dropZoneActive="active"></slot>
            <div class="relative w-full h-full">
                <v-overlay v-model="active" class="align-center justify-center" contained>
                    <div class="flex justify-center items-center">
                        <v-icon size="25" color="white">$fa-file-upload</v-icon>
                        <span class="text-white text-h5 font-weight-bold">
                            Déposez votre fichier
                        </span>
                    </div>
                </v-overlay>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
const emit = defineEmits<{
    "files-dropped": [File[]];
}>();

const active = ref<boolean>(false);
let inActiveTimeout = null;

const setActive = () => {
    active.value = true;
    clearTimeout(inActiveTimeout);
};
const setInactive = () => {
    inActiveTimeout = setTimeout(() => {
        active.value = false;
    }, 50);
};

const onDrop = (e) => {
    setInactive();
    emit("files-dropped", [...e.dataTransfer.files] as File[]);
};

const preventDefaults = (e) => {
    e.preventDefault();
};

const events = ["dragenter", "dragover", "dragleave", "drop"];

onMounted(() => {
    events.forEach((eventName) => {
        document.body.addEventListener(eventName, preventDefaults);
    });
});

onUnmounted(() => {
    events.forEach((eventName) => {
        document.body.removeEventListener(eventName, preventDefaults);
    });
});
</script>
